import { cn } from '../lib/utils';

/**
 * Nsibi mark - a ring carrying two forward chevrons, drawn as free clay
 * strokes on a transparent background. Stroke weight is bumped slightly
 * above the master artwork so the outline still reads at 32px.
 *
 * A ring, not a speech bubble, since 2026-09-21: the tail read as another
 * messenger's mark. The same drawing with the tail off, re-centred and a
 * fifth larger in its box, so a `size-12` glyph is a bigger logo than it
 * was. The old one is in `branding/archive/2026-09-bubble/`.
 */
export function Glyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" className={className} aria-hidden="true">
      <g stroke="#B5532A" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <circle cx="256" cy="256" r="200" />
        <path d="M -71 -71 L 0 0 L -71 71" transform="translate(326 197) rotate(-40)" />
        <path d="M -71 -71 L 0 0 L -71 71" transform="translate(250 261) rotate(-40)" />
      </g>
    </svg>
  );
}

export function Logo({
  className,
  showWordmark = true,
}: {
  className?: string;
  showWordmark?: boolean;
}) {
  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      <Glyph className="size-12" />
      {showWordmark && (
        <span className="text-[1.375rem] font-semibold tracking-[-0.02em] text-foreground">
          Nsibi
        </span>
      )}
    </span>
  );
}
